<template>
  <div class="header" :class="{ 'header--relative': props.isRelative }">
    <div class="header__left">
      <div class="header__back" :class="{ 'header__back--black': props.backBlack }" @click="goback"></div>
    </div>
    <div class="header__title">
      {{ props.title || '' }}
    </div>
    <div class="header__right"></div>
  </div>
</template>
<script setup>
import { ref, defineProps } from 'vue'
const bridge = window.bridge
const props = defineProps({
  backBlack: {
    type: Boolean,
    default: false
  },
  isRelative: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  customBack: {
    type: String,
    default: ''
  },
})
const emit = defineEmits(['back'])
const goback = () => {
  if (props.customBack) {
    emit('back')
    return
  }
  bridge.navigateBack()
}
</script>
<style lang="scss" scoped>
.header {
  height: 90px;
  padding: 0 40px;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  position: fixed;
  z-index: 1;
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;

  &.header--relative {
    position: relative;
  }
  &>* {
    width: 1%;
    flex-grow: 1;
  }
}
.header__title {
  text-align: center;
  color: #262626;
  font-size: 32px;
}
.header__back {
  width: 90px;
  height: 90px;
  position: relative;

  &::after {
    content: '';
    width: 15px;
    height: 15px;
    border-left: 4px solid #fff;
    border-bottom: 4px solid #fff;
    transform: rotate(45deg);
    position: absolute;
    left: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &.header__back--black {
    &::after {
      border-left: 4px solid #000;
      border-bottom: 4px solid #000;
    }
  }
}
</style>